function filterSede() {
    if (localStorage.getItem('idCustomerOffice') !== null) {
        return [
            {
                fieldName: 'idCustomer',
                type: "value",
                value: localStorage.getItem('idCustomerOffice')
            }
        ]
    } else {
        return []
    }

}
function filter01() {
    if (localStorage.getItem('idSalesAgentCatalog') !== null) {
        return [
            {
                fieldName: 'catalogs',
                type: localStorage.getItem('idSalesAgentCatalog') ? "in_ext" : "like",
                value: localStorage.getItem('idSalesAgentCatalog') ? localStorage.getItem('idSalesAgentCatalog') : ''
            }
        ]
    } else {
        return []
    }

}
function filterWarehouse() {
    return [
        {
            fieldName: 'internal',
            type: "value",
            value: 1
        }
    ]
}
function filterOutlet() {
    return [
        {
            fieldName: 'outlet',
            type: "value",
            value: 1
        }
    ]
}
function filterSedeOffer() {
    return [
        {
            fieldName: 'idCustomer',
            type: localStorage.getItem('idCustomerOfficeOffer') ? "in" : "in",
            value: localStorage.getItem('idCustomerOfficeOffer') ? localStorage.getItem('idCustomerOfficeOffer') : ''
        }
    ]
}
function filterSedeOrderSupplier() {
    if (localStorage.getItem('idSupplierOfficeOrder') !== null) {
        return [
            {
                fieldName: 'idSupplier',
                type: localStorage.getItem('idSupplierOfficeOrder') ? "in" : "in",
                value: localStorage.getItem('idSupplierOfficeOrder') ? localStorage.getItem('idSupplierOfficeOrder') : ''
            }
        ]
    } else {
        return []
    }
}
function filterCustomer() {
    return [
        {
            fieldName: 'visible',
            type: "value",
            value: 1
        },
        {
            fieldName: 'isBlocked',
            type: "value",
            value: 0
        }
    ]
}
function filterShippingPlan() {
    return [
        {
            fieldName: 'status',
            type: "value",
            value: "0_DRAFT"
        }
    ]
}
function filterItemModelSupplierOrder() {
    return [
        {
            fieldName: 'idItemModel',
            type: "value",
            value: localStorage.getItem('idItemModelSupplierOrder')
        },
        {
            fieldName: 'active',
            type: "value",
            value: 1
        }
    ]
}
function filterIMCustomerOrderRows() {
    return [
        {
            fieldName: 'picking',
            type: "value",
            value: 1
        },
        {
            fieldName: 'type',
            type: "value",
            value: "30_PRODOTTI_VENDITA"
        },
    ]
}
export const customFilters = {
    filterItemModelSupplierOrder: filterItemModelSupplierOrder,
    filterShippingPlan: filterShippingPlan,
    filterCustomer: filterCustomer,
    filterSedeOrderSupplier: filterSedeOrderSupplier,
    filterSedeOffer: filterSedeOffer,
    filterWarehouse: filterWarehouse,
    filter01: filter01,
    filterSede: filterSede,
    filterOutlet: filterOutlet,
    filterIMCustomerOrderRows: filterIMCustomerOrderRows
};